/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type signedInViewer_superUserOrgs$ref: FragmentReference;
declare export opaque type signedInViewer_superUserOrgs$fragmentType: signedInViewer_superUserOrgs$ref;
export type signedInViewer_superUserOrgs = {|
  +nodes: $ReadOnlyArray<?{|
    +id: string,
    +rowId: any,
    +name: string,
    +avatar: ?string,
    +organizationType: string,
    +primaryOrganization: ?{|
      +rowId: any,
      +name: string,
      +organizationType: string,
    |},
  |}>,
  +$refType: signedInViewer_superUserOrgs$ref,
|};
export type signedInViewer_superUserOrgs$data = signedInViewer_superUserOrgs;
export type signedInViewer_superUserOrgs$key = {
  +$data?: signedInViewer_superUserOrgs$data,
  +$fragmentRefs: signedInViewer_superUserOrgs$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rowId",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "organizationType",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "signedInViewer_superUserOrgs",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Organization",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        (v0/*: any*/),
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "avatar",
          "storageKey": null
        },
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Organization",
          "kind": "LinkedField",
          "name": "primaryOrganization",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/),
            (v2/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "OrganizationsConnection"
};
})();
// prettier-ignore
(node/*: any*/).hash = 'e2b5247ee493e50c8fa4d457b3423807';

module.exports = node;
